import { styled } from "styled-components";

export const CartControlContainer = styled.div<{
  $altStyling?: boolean;
  $active: boolean;
}>`
  height: 100%;
  min-height: 100%;
  max-width: max-content;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: pointer;
  background: ${({ theme, $active, $altStyling }) =>
          $active && !$altStyling ? theme.colors.primary[900] : "transparent"};
  border-radius: 6px;

  svg {
    path {
      fill: ${({ theme, $active }) =>
              $active ? theme.colors.secondary[50] : theme.colors.default[600]};
    }
  }
`;

export const Count = styled.span`
  position: absolute;
  top: -2px;
  right: 0;
  font-size: 8px;
  font-weight: 700;
  height: 12px;
  min-width: 12px;
  text-align: center;
  color: ${({ theme }) => theme.colors.base};
  border-radius: 10px;
  width: max-content;
  padding: 3px;
  background: ${({ theme }) => theme.colors.primary.default};
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 100%;
  outline: 2px solid ${({ theme }) => theme.colors.primary[950]};
`;
